import * as types from '../action-types';
import { closeHighlightPopover } from './highlight';
import { closeActionSidebarRemovePopover } from './actionSidebarRemove';
import { storeSelectionId } from './decisionSelection';

type openProps = {
  isRemove: boolean;
  top: number;
  left: number;
};

const openActionSidebarPopover = (data: openProps) =>
  <const>{
    type: types.openActionSidebarPopover,
    payload: { data },
  };

export const checkOpenActionSidebarPopover = (data: openProps) => (
  dispatch: Function,
) => {
  dispatch(openActionSidebarPopover(data));
  // close highlightPopover or actionSidebarRemovePopover as user selection has popover priority
  dispatch(closeHighlightPopover());
  dispatch(closeActionSidebarRemovePopover());
};

export const closeActionSidebarPopover = () => {
  return <const>{
    type: types.closeActionSidebarPopover,
  };
};

export const checkCloseActionSidebarPopover = () => (
  dispatch: Function,
  getState: Function,
) => {
  const {
    decision: { actionSidebar },
  } = getState();
  if (actionSidebar.isOpen) {
    dispatch(closeActionSidebarPopover());
    dispatch(storeSelectionId(null));
  }
};

export const switchActionSidebarRemove = () =>
  <const>{
    type: types.switchActionSidebarRemove,
  };

export type ActionSidebarActions = ReturnType<
  | typeof openActionSidebarPopover
  | typeof closeActionSidebarPopover
  | typeof switchActionSidebarRemove
>;
